module.exports = function getResource(label, vars = []) {
    const resources = {
        automaticUpdate: 'Choosing a date will automatically update the stores and time slots that are displayed.',
        chooseDate: 'Choose a Date',
        seeMoreDates: 'See more dates'
    };

    return resources[label];
};
